import {
  createClient as createSupabaseClient,
  type SupabaseClient,
} from '@supabase/supabase-js';

let browserClient: SupabaseClient | undefined;

/** Single browser Supabase client — avoids multiple GoTrueClient / storage-key warnings. */
export function createClient(): SupabaseClient {
  if (!browserClient) {
    browserClient = createSupabaseClient(
      process.env.NEXT_PUBLIC_SUPABASE_URL!,
      process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
    );
  }
  return browserClient;
}
